/**
 * WHAT «NUEVA VENTA» OPENS, read off the business type's profile and its
 * modules, never stored (spec 2026-09-28 §4.2). Each client turns `form` into
 * its own route; no screen asks the type's name. Null: this business does not
 * sell, and its «+» is the Libro's loose income.
 */
import { FACES, facesFor, workFace } from "./faces.js";
import { hasModule } from "./modules.js";
import { plateSaleOf, verticalOf } from "./verticals.js";
/** The modules that give a business «Nueva venta»: any of them. */
export const SALE_DOOR_MODULES = ["pedidos", "citas"];
export function saleDoor(businessType, modules) {
    if (SALE_DOOR_MODULES.some((id) => hasModule(modules, id))) {
        // A menu's faces (a table, a takeaway) are ways of serving, not dates: their own form.
        if (facesFor(businessType).some((face) => FACES[face].linesFromMenu))
            return { form: "table", face: null, startsAt: null };
        // A trade that sells by plate (the car wash): the same document and face, its own entry form.
        if (plateSaleOf(businessType) !== null)
            return { form: "plate", face: workFace(businessType), startsAt: "now" };
        return { form: "document", face: workFace(businessType), startsAt: verticalOf(businessType).startsAt ?? "now" };
    }
    return null;
}
export function saleScreenOf(door) {
    if (door.form === "plate")
        return "plate";
    if (door.face !== null && FACES[door.face].sideRow === "appointment")
        return "agenda";
    return "document";
}
